import {connect} from '../../app/connect';
import IssueTypeSelectDropdown from './IssueTypeSelectDropdown';
import {
  getActiveIssueSubTypesGroupedDropdownOptionsWithLabelValueMap,
  getIssueTypesAdminEntitiesMapWithLabelValueMap
} from '../../app/selectors';

const mapStateToProps = state => ({
  activeIssueSubTypesGroupedDropdownOptions: getActiveIssueSubTypesGroupedDropdownOptionsWithLabelValueMap(state),
  fieldIssueTypeEntitiesMap: getIssueTypesAdminEntitiesMapWithLabelValueMap(state)
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueTypeSelectDropdown);
